var ctDutyWishPeriodModel;
(function ($) {
 	$.fn.capitechDutyWishPeriod = function() {
		var properties = {
			extend: {
				"{root}": function (root) {
					root.selectedDutyWishPeriod = ko.viewmodel.fromModel({bNew:true});
					root.dutyWishFormData = ko.viewmodel.fromModel(dutyWishFormData());
					root.deleteDutyWishPeriodClick = function (dutyWishPeriod) {
						deleteDutyWishPeriod(dutyWishPeriod);
					};
					root.editDutyWishPeriodClick = function (dutyWishPeriod) {
						ctDutyWishPeriodModel.selectedDutyWishPeriod = dutyWishPeriod;
					};
					root.addDutyWishPeriodClick = function (dutyWishPeriod) {
						$.magnificPopup.open({
							mainClass: 'dialog-slide-bottom',
							closeOnBgClick: false,
							items: {
								src: $('#ct-create-dutywish-period'),
								type: 'inline'
							},
							callbacks: {
								open: function() {
									var $thisElm = $(this.container[0]);
									initializeComponents($thisElm);
									// Translate labels
									translateGUI($thisElm);
								}
							}
						});
					};
					return root;
				},
				"{root}.dutyWishPeriods[i]": function(dutyWishPeriod) {
					dutyWishPeriod.shortNoticeText = ko.computed(function() {
						var currentStatus = dutyWishPeriod.isEmployeeAvaliableOnShortNotice();
						if (currentStatus) {
							return getResource('dutyWish.shortNoticeTextTrue', 'Ja');
						} else {
							return getResource('dutyWish.shortNoticeTextFalse', 'Nei');
						}
					}, dutyWishPeriod);
					return dutyWishPeriod
				}
			}
		}
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			var modelData = {};
			modelData.dutyWishPeriods = [];
			ctDutyWishPeriodModel = ko.viewmodel.fromModel(modelData, properties);
			$('*[data-ko-bind="ctDutyWishPeriodModel"]').each(function(index, obj) {
				ko.applyBindings(ctDutyWishPeriodModel,obj);
			});
			getDutyWishPeriods();
		}
		
		function getDutyWishPeriods() {
			var success = function(data, textStatus, jqXHR) {
				var modelData = {};
				loaderIndicator(false);
				if (data.success == true) {
					if (data.content.length > 0) {
						modelData.dutyWishPeriods = data.content;
						ko.viewmodel.updateFromModel(ctDutyWishPeriodModel, modelData);
					}
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			}
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator();
			_api.getDutyWishPeriods_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), '2015-01-01', '2015-12-12');
		}
		
		function deleteDutyWishPeriod(dutyWishPeriod) {
			var success = function(data, textStatus, jqXHR) {
				loaderIndicator(false);
				if (data.success == false) {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				} else {
					ctDutyWishPeriodModel.dutyWishPeriods.remove(dutyWishPeriod);
				}
			}
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator();
			_api.deleteDutyWishPeriod_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), dutyWishPeriod.fromDate());
		}
		
		$('.ct-btn-select-all').click(function(evt) {
			evt.preventDefault();
			var $this = $(this);
			var markCheckbox = true;
			if ($this.val() == 'false') {
				markCheckbox = false;
			}
			$this.parents('.col-md-4').find('.ct-checkbox-group input:checkbox').each(function(index, obj) {
				$(obj).prop('checked', markCheckbox);
			});
		});
		
		$(this).find('form').submit(function(evt) {
			evt.preventDefault();
			var $this = $(this);
			var aNewDepartmentIds = [];
			var aNewDutyTypeIds = [];
			var aNewDays = [];
			var isEmployeeAvaliableOnShortNotice = $this.find('#dutyWishPeriodAvaliableOnShortNotice').is(':checked');
			var comment = $this.find('#dutyWishComment').val();
			var dateFrom = $this.find('#dutyWishPeriodDateFrom').val();
			var dateTo = $this.find('#dutyWishPeriodDateTo').val();
			var success = function(data, textStatus, jqXHR) {
				loaderIndicator(false);
				if (data.success == true) {
					if (ctDutyWishPeriodModel.selectedDutyWishPeriod.bNew()) {
						getDutyWishPeriods();
					}
					$.magnificPopup.close();
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			}
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			
			$this.find('input[name=departmentIds]:checked').map(function() {
				aNewDepartmentIds.push(parseInt($(this).val()));
			});
			$this.find('input[name=dutyTypeIds]:checked').map(function() {
				aNewDutyTypeIds.push(parseInt($(this).val()));
			});
			$this.find('input[name=days]:checked').map(function() {
				aNewDays.push(parseInt($(this).val()));
			});
			
			loaderIndicator();
			_api.createDutyWishPeriod_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				dateFrom, // fromDate
				dateTo, // toDate
				aNewDays, // requestedDaysOfWeek
				aNewDepartmentIds, // requestedDepartmentIds
				aNewDutyTypeIds, // requestedDutyTypeIds
				comment, // commentFromEmployee
				isEmployeeAvaliableOnShortNotice// isEmployeeAvaliableOnShortNotice
			);
		});
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));